module.exports = __webpack_public_path__ + "static/media/dramaImg6.732bc23e.jpg";